import TimelineGroupModel from "./TimelineGroupModel";

export default class TimelineConfiguration {
	constructor(data: any) {
		if (data) {
			this.width = data.width ?? '100%';
			this.height = data.height ?? '100px';
			this.date = data.date ?? new Date(1970,0,1);
			this.shiftStartHour = data.shiftStartHour ?? 0;
			this.shiftEndHour = data.shiftEndHour ?? 0;
			
			if (data.timelines?.length) {
				this.timelines = data.timelines.map((_: any) => new TimelineGroupModel(_));
			}
		}
	}

	width = '100%';
	height = '100px';
	date: Date = new Date(1970, 0, 1);
	shiftStartHour = 0;
	shiftEndHour = 0;
	
	timelines: Array<TimelineGroupModel> = [];
}